
import { GlobalController } from 'src/shared/global/GlobalController'
import MtrComponentGroup from './MtrComponentGroup'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'mtrComponentGroup',
    component: MtrComponentGroup,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
